export interface StockSearch {
  search: string;
}
